import { Conversation } from '../chat/chat.models';

export const MOCK_CONVERSATIONS: Conversation[] = [
  {
    id: 'failed-empty',
    title: 'IPO Exit Funds 2024-2025',
    updatedAtLabel: 'Feb 12',
    status: 'failed',
  },
  {
    id: 'fb804c5d513ffa09',
    title: 'Success Rate Analysis of Crawl Data',
    updatedAtLabel: 'Nov 26',
  },
  {
    id: 'flight-options',
    title: 'Bengaluru-Visakhapatnam Same-Day Flight Options',
    updatedAtLabel: 'Nov 17',
  },
  { id: 'fat-plan', title: 'Reduce Belly Fat: 2-Week Plan', updatedAtLabel: 'Nov 17' },
  { id: 'deep-research', title: 'Building a Deep Research Agent', updatedAtLabel: 'Nov 14' },
  { id: 'health-tracker', title: 'Health Tracker', updatedAtLabel: 'Nov 14' },
  { id: 'fitness-plan', title: 'Fitness Plan', updatedAtLabel: 'Nov 14' },
  { id: 'diet-plan', title: 'Diet Plan', updatedAtLabel: 'Nov 14' },
  { id: 'sleep-tracker', title: 'Sleep Tracker', updatedAtLabel: 'Nov 14' },
  { id: 'mood-tracker', title: 'Mood Tracker', updatedAtLabel: 'Nov 14' },
  { id: 'productivity-tracker', title: 'Productivity Tracker', updatedAtLabel: 'Nov 14' },
  { id: 'finance-tracker', title: 'Finance Tracker', updatedAtLabel: 'Nov 14' },
  { id: 'travel-plan', title: 'Travel Plan', updatedAtLabel: 'Nov 14' },
  { id: 'home-security', title: 'Home Security', updatedAtLabel: 'Nov 14' },
  { id: 'home-automation', title: 'Home Automation', updatedAtLabel: 'Nov 14' },
  { id: 'home-security-2', title: 'Home Security', updatedAtLabel: 'Nov 14' },
  { id: 'home-automation-2', title: 'Home Automation', updatedAtLabel: 'Nov 14' },
  { id: 'home-security-3', title: 'Home Security', updatedAtLabel: 'Nov 14' },
  { id: 'recipe-finder', title: 'Recipe Finder', updatedAtLabel: 'Nov 13' },
  { id: 'weather-app', title: 'Weather App', updatedAtLabel: 'Nov 13' },
  { id: 'news-reader', title: 'News Reader', updatedAtLabel: 'Nov 12' },
  { id: 'podcast-manager', title: 'Podcast Manager', updatedAtLabel: 'Nov 12' },
  { id: 'book-tracker', title: 'Book Tracker', updatedAtLabel: 'Nov 11' },
  { id: 'movie-list', title: 'Movie Watchlist', updatedAtLabel: 'Nov 11' },
  { id: 'music-player', title: 'Music Player', updatedAtLabel: 'Nov 10' },
  { id: 'photo-gallery', title: 'Photo Gallery', updatedAtLabel: 'Nov 10' },
  { id: 'note-taking', title: 'Note Taking App', updatedAtLabel: 'Nov 9' },
  { id: 'task-manager', title: 'Task Manager', updatedAtLabel: 'Nov 9' },
  { id: 'calendar-app', title: 'Calendar App', updatedAtLabel: 'Nov 8' },
];
